module.exports = __webpack_public_path__ + "e23675bf90e90f4b57c5df8aa3052460.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/jam-pad-main.png
// module id = 575
// module chunks = 0